import Analytics from '@opencare/analytics';

import Logger from 'utils/Logger';

interface ErrorResponse {
  response?: {
    data?: {
      errors?: string[];
      message?: string;
    };
  };
  message?: string;
}

export const extractErrorMessage = (error: ErrorResponse) => {
  const apiMessage = error?.response?.data?.errors?.[0];

  // Failsafe this method just in case no message is found
  return apiMessage || error?.message || error;
};

export const extractErrorDetails = (error: ErrorResponse) => {
  const apiMessage = error?.response?.data?.message;

  if (apiMessage) {
    return {
      error_details: apiMessage,
    };
  }

  return null;
};

const analytics = new Analytics();

/**
 * Send an error to Rollbar.
 * DO NOT SEND INFORMATION THAT COULD POTENTIALLY BE USED TO IDENTIFY A PATIENT.
 */
export const sendToLogger = (error: ErrorResponse, methodName: string, errorDetails: string) => {
  const errorMessage = String(extractErrorMessage(error));
  const errorData = error.response?.data;

  analytics.trackError({
    pageType: analytics.pageTypes.ERROR,
    pageName: 'sendToLogger',
    content: {
      error_message: JSON.stringify(errorMessage),
      method_that_threw_error: JSON.stringify(methodName),
      error_details: JSON.stringify(errorDetails),
      error_data: JSON.stringify(errorData),
    },
  });

  const errorToLog = typeof error === 'string' ? new Error(error) : error;

  // Anything in customData is sent directly to Rollbar
  const customData = {
    error_data: errorData,
    error_message: errorMessage,
    method_that_threw_error: methodName,
    error_details: errorDetails,
  };

  Logger.error(`API: ${errorMessage}`, errorToLog, customData);
};
